import HotAssets from "./HotAssets.jsx";
import {useSelector} from "react-redux";
import {getIsHotAssetsVisible} from "../../ducks/assets-duck.js";

export default () => {
    const isHotAssetsVisible = useSelector(getIsHotAssetsVisible)
    return (
        isHotAssetsVisible && <HotAssets />
    )
}